/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { TagsInput } from "react-tag-input-component";
import "primereact/resources/themes/bootstrap4-light-blue/theme.css";
import { Dropdown } from "primereact/dropdown";
import {
  createNotes,
  deleteClient,
  deleteClients,
  getSubscriptionByCompanylist,
  updataClientUserApi,
  updateChoiseStatus,
} from "../services/client/addclientApi";
import BreadCrumbs from "../components/Common/BreadCrumbs";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../components/Common/Loader";
import {
  BsCheck,
  BsChevronLeft,
  BsChevronRight,
  BsChevronUp,
  BsFunnel,
  BsPersonPlus,
  BsTrash,
  BsX,
  BsXLg,
} from "react-icons/bs";
import { BsChevronDown } from "react-icons/bs";
import AddNewProspect from "../components/Prospect/AddProspect";
import { NavLink, useNavigate } from "react-router-dom";
import { pagination } from "../components/Common/Pagination";
import TableFooter from "../components/Common/TableFooter";
import {
  alphabeticalBasic,
  fetchcompanyDropdown,
  searchProsUserList,
  setProspectSearches,
  setProspectSortBy,
} from "../Redux/commonSlice";
import DeleteModal from "../components/Common/DeleteModal";
import RoleAndsubscriptionname from "../components/Prospect/Components/RoleAndsubscriptionname";
import moment from "moment/moment";
import { ReactComponent as PlusIcon } from "../assets/img/icons/fleet/plus.svg";
import { ReactComponent as FilterIcon } from "../assets/img/icons/fleet/filter.svg";
import { ReactComponent as SettingIcon } from "../assets/img/icons/fleet/settings.svg";
import { ReactComponent as DotsVertIcon } from "../assets/img/icons/fleet/dots-vertical.svg";
import { ReactComponent as UserPlusIcon } from "../assets/icons/user-plus.svg";
import { ReactComponent as ReportSearchIcon } from "../assets/icons/report-search.svg";
import { Modal } from "react-bootstrap";
import { getAdminUsers } from "../services/Adminuser";
import { schengenCountries } from "../components/Common/AddressAutocompleteInput";
import DaterangePicker from "../components/Prospect/DateRange";
import { OverlayPanel } from "primereact/overlaypanel";
import { isUnder23 } from "../components/Prospect/Components/ProspectDetails";
import SearchableOptions from "../components/SearchableOptions";
import { roleClasses } from "../components/Common/roles";
import { exportToCSV } from "../utils/csvExport";

const Prospect = () => {
  const { permissions } = useSelector((state) => state.userSlice);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [addShow, setAddShow] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [clientId, setclientId] = useState(null);
  const [isSubscriptionValue, setSubscriptionValue] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setitemsPerPage] = useState(25);
  const [assignUser, setAssignUser] = useState(false);
  const [initialValue, setInitialValue] = useState({
    search: "",
    company: "",
    status: "",
    subscription: "",
  });
  const [reload, setReload] = useState(false);

  const [showFilters, setShowFilters] = useState(false);
  const [filterOpts, setFilterOpts] = useState([]);
  const [filterKey, setFilterKey] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [prospectSearch, setProspectSearch] = useState({
    search: "",
    company: [],
    status: [],
    subscription: [],
    assignedUser: [],
    calendar: null,
  });
  const overlayPanelRef = useRef(null);

  const handleSubmitAssignedUser = async (e) => {
    // setReload();
    searchMyProspects(e);
    // overlayPanelRef.current.toggle(e);
  };

  const {
    companyDropdown,
    basicList,
    tempBasicList,
    loading,
    prospectSearches,
    prospectSortBy,
    prospectPagination,
  } = useSelector((state) => state?.commonSlice);

  const [users, setUsers] = useState([]);

  useEffect(() => {
    getAdminUsers().then((res) => {
      const result = res.data.map((r) => ({
        fullName: `${r.fname} ${r.lname}`,
        fName: r.fname,
        lName: r.lname,
        email: r.email,
        role: r.role,
        _id: r._id,
      }));
      setUsers(result);
    });
  }, []);

  // pagination start
  const basicListData = basicList; //pagination(basicList, currentPage, itemsPerPage);
  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };
  // pagination end

  // subscriptionDropdownValue start
  const subscriptionDropdownValue = async (id) => {
    const subscriptionValue = await getSubscriptionByCompanylist(id);
    if (subscriptionValue !== undefined) {
      setSubscriptionValue(subscriptionValue?.data);
    } else {
      setSubscriptionValue([]);
    }
  };
  // subscriptionDropdownValue end

  const handleSelectChange = (e) => {
    setitemsPerPage(e.value);
  };

  const handleDateRangeChange = (range) => {
    console.log(range);
    dispatch(setProspectSearches({ ...prospectSearches, calendar: range }));
  };

  const aTozSorting = (key) => {
    dispatch(setProspectSortBy({ key, order: "asc" }));
    // // Create a temporary array with 'member' assigned to 'comp_id.name' for sorting.
    // const tempData = tempBasicList.map((item) => ({
    //   ...item,
    //   member: item?.comp_id?.name,
    // }));

    // // Perform A-to-Z (ascending) sorting based on the key.
    // const sortedData = tempData.sort((a, b) => {
    //   // Handle potential undefined or null values gracefully.
    //   const valA = a?.[key] ?? "";
    //   const valB = b?.[key] ?? "";

    //   // Check if the key is 'index' to perform numerical sorting.
    //   if (key === "index") {
    //     return Number(valA) - Number(valB); // Ascending numerical sort
    //   }

    //   return valA.localeCompare(valB);
    // });

    // // Dispatch the sorted data to the store.
    // dispatch(alphabeticalBasic(sortedData));
  };

  const zToaSorting = (key) => {
    dispatch(setProspectSortBy({ key, order: "desc" }));
    // // Create a temporary array with 'member' assigned to 'comp_id.name' for sorting.
    // const tempData = tempBasicList.map((item) => ({
    //   ...item,
    //   member: item?.comp_id?.name,
    // }));

    // // Perform Z-to-A (descending) sorting based on the key.
    // const sortedData = tempData.sort((a, b) => {
    //   // Handle potential undefined or null values gracefully.
    //   const valA = a?.[key] ?? "";
    //   const valB = b?.[key] ?? "";

    //   // Check if the key is 'index' to perform numerical sorting.
    //   if (key === "index") {
    //     return Number(valB) - Number(valA); // Descending numerical sort
    //   }

    //   return valB.localeCompare(valA);
    // });

    // // Dispatch the sorted data to the store.
    // dispatch(alphabeticalBasic(sortedData));
  };

  const handleSingleProspect = async (customer) => {
    if (customer?.role?.length > 1) {
      navigate(`/client/profile/${customer?._id}`);
    } else {
      if (customer?.role?.includes("BASIC")) {
        navigate(`/prospect/document/${customer?._id}`);
      } else if (
        customer?.role?.includes("AUX") ||
        customer?.role?.includes("MAIN")
      ) {
        navigate(`/driver/profile/${customer?._id}`);
      } else if (customer?.role?.includes("MAIN")) {
        navigate(`/driver/profile/${customer?._id}`);
      } else if (
        customer?.role?.includes("CLIENT") ||
        customer?.role?.includes("SINGLE")
      ) {
        navigate(`/client/profile/${customer?._id}`);
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(value);
    setCurrentPage(0);
    if (name === "choise_status") {
      const finalVal = prospectSearches[name]?.find(
        (r) => r?.key === value?.key
      )
        ? prospectSearches[name]?.filter((r) => r?.key !== value?.key)
        : [...prospectSearches[name], value];
      dispatch(setProspectSearches({ ...prospectSearches, [name]: finalVal }));
      return;
    }
    if (name === "status") {
      const finalVal = prospectSearches[name]?.find(
        (r) => r?.value === value?.value
      )
        ? prospectSearches[name]?.filter((r) => r?.value !== value?.value)
        : [...prospectSearches[name], value];
      dispatch(setProspectSearches({ ...prospectSearches, [name]: finalVal }));
      return;
    }
    if (name === "company") {
      const finalVal = prospectSearches[name]?.find(
        (r) => r?._id === value?._id
      )
        ? prospectSearches[name]?.filter((r) => r?._id !== value?._id)
        : [...prospectSearches[name], value];
      dispatch(setProspectSearches({ ...prospectSearches, [name]: finalVal }));
      return;
    }
    dispatch(setProspectSearches({ ...prospectSearches, [name]: value }));
  };

  const handleDelete = async (id) => {
    const form = new FormData();
    form.append("role", ["MAIN", "CLIENT", "AUX", "BASIC"]);
    await deleteClient(clientId);
    setModalShow(false);
    dispatch(searchProsUserList(form));
  };

  // Handle tag change
  const handleTagChange = async (id, newTags) => {
    const body = { tags: newTags };
    await createNotes(id, body);
  };

  const Status = [
    { label: "Basic", value: "BASIC" },
    { label: "Client", value: "CLIENT" },
    { label: "AUX", value: "AUX" },
    { label: "One", value: "One" },
    { label: "Plus", value: "Plus" },
    { label: "Demande", value: "Demande" },
    { label: "Single", value: "Single" },
  ];

  const filters = [
    { key: "company", label: "Société" },
    { key: "status", label: "Status" },
    { key: "localisation", label: "Localisation" },
    { key: "calendar", label: "Date de Creation" },
    { key: "choise_status", label: "État de la demande" },
  ];

  useEffect(() => {
    const form = new FormData();
    console.log(prospectSearches);
    if (prospectSearches?.search)
      form.append("searchname", prospectSearches?.search);
    if (prospectSearches?.company)
      form.append(
        "comp_id",
        prospectSearches?.company?.map((r) => r?._id).join(",")
      );
    if (prospectSearches?.subscription?._id)
      form.append("sub_id", prospectSearches?.subscription?._id);
    if (prospectSearches?.status)
      form.append(
        "role",
        prospectSearches?.status?.map((r) => r?.value?.toLowerCase()).join(",")
      );
    if (prospectSearches?.assignedUser)
      form
        .append(
          "assignedUser",
          prospectSearches?.assignedUser?.map((r) => r._id)
        )
        ?.join(",");
    if (prospectSearches?.choise_status)
      form.append(
        "choise_status",
        prospectSearches?.choise_status?.map((r) => r?.key).join(",")
      );
    if (prospectSearches?.calendar) {
      form.append("startDate", prospectSearches.calendar[0]);
      form.append("endDate", prospectSearches.calendar[1]);
    }

    form.append("page", currentPage + 1);
    form.append("perPage", itemsPerPage);
    form.append("sortKey", prospectSortBy?.key);
    form.append("sortOrder", prospectSortBy?.order);

    const debounceTimeout = setTimeout(() => {
      dispatch(searchProsUserList(form));
    }, 300);

    return () => {
      clearTimeout(debounceTimeout);
    };
  }, [
    prospectSearches?.search,
    prospectSearches?.company,
    prospectSearches?.subscription,
    prospectSearches?.status,
    prospectSearches?.assignedUser,
    prospectSearches?.calendar,
    prospectSearches?.choise_status,
    prospectSortBy?.key,
    prospectSortBy?.order,
    currentPage,
    itemsPerPage,
    reload,
  ]);

  useEffect(() => {
    dispatch(fetchcompanyDropdown());
  }, []);

  // useEffect(() => {
  //   if (prospectSortBy?.key && tempBasicList.length > 0) {
  //     if (prospectSortBy?.order === "aToz") aTozSorting(prospectSortBy?.key);
  //     if (prospectSortBy?.order === "zToa") zToaSorting(prospectSortBy?.key);
  //   }
  // }, [tempBasicList]);

  const toggleAssignUser = (user) => {
    setAssignUser(assignUser ? false : user);
  };

  const toggleFilters = () => {
    setShowFilters(!showFilters);
    setFilterKey("");
    setFilterOpts([]);
    setProspectSearch(false);
  };

  const toggleFilterOpts = (key) => {
    const opts = {
      company: companyDropdown,
      status: Status,
      localisation: schengenCountries,
      calendar: [
        {
          key: "today",
          label: "Aujourd’hui",
          range: () => {
            const today = moment().format("YYYY/MM/DD");
            return [today, today];
          },
        },
        {
          key: "last7days",
          label: "Les 7 derniers Jours",
          range: () => {
            const today = moment().format("YYYY/MM/DD");
            const past = moment().subtract(6, "days").format("YYYY/MM/DD");
            return [past, today]; // From 6 days ago to today (7 days total)
          },
        },
        {
          key: "lastmonth",
          label: "Dans le dernier mois",
          range: () => {
            const today = moment().format("YYYY/MM/DD");
            const past = moment().subtract(1, "month").format("YYYY/MM/DD");
            return [past, today]; // From same date last month to today
          },
        },
      ],
      choise_status: [
        {
          label: "Call 1",
          key: "call_1",
        },
        {
          label: "Mail 1",
          key: "mail_1",
        },
        {
          label: "Call 2",
          key: "call_2",
        },
        {
          label: "Call 3",
          key: "call_3",
        },
        {
          label: "Mail 2",
          key: "mail_2",
        },
        {
          label: "Mail 3",
          key: "mail_3",
        },
        {
          label: "Contrat envoyé",
          key: "contract_sent",
        },
        {
          label: "Traité",
          key: "treaty",
        },
        {
          label: "Conversion",
          key: "conversion",
        },
        {
          label: "Cloturé",
          key: "cloture",
        },
        {
          label: "Pas éligible",
          key: "pas_eligible",
        },
        {
          label: "A Traiter",
          key: "a_traiter",
        },
        {
          label: "Document manquant",
          key: "document_manquant",
        },
      ],
    };

    toggleFilters();
    setFilterKey(key);
    setFilterOpts(opts[key]);
  };

  const handleDateFilter = (option) => {
    const selectedRange = option.range(); // Get predefined range
    setCurrentPage(0);
    dispatch(
      setProspectSearches({
        ...prospectSearches,
        calendar: selectedRange, // Update the calendar field with the range
      })
    );
  };

  const searchMyProspects = (selectedU) => {
    setCurrentPage(0);

    const vals =
      typeof prospectSearches?.assignedUser === "string"
        ? [{ label: selectedU?.fullName, _id: selectedU?._id }]
        : prospectSearches?.assignedUser?.find((r) => r._id === selectedU?._id)
        ? prospectSearches?.assignedUser?.filter(
            (r) => r._id !== selectedU?._id
          )
        : [
            ...prospectSearches?.assignedUser,
            { label: selectedU?.fullName, _id: selectedU?._id },
          ];
    dispatch(
      setProspectSearches({
        ...prospectSearches,
        assignedUser: vals.length === 0 ? "" : vals,
      })
    );
    setProspectSearch(true);
  };

  const toggleDeleteConfirmation = () =>
    setDeleteConfirmation(!deleteConfirmation);

  const deleteSelectedRows = async () => {
    try {
      await deleteClients({ ids: selectedRows });
      setReload(!reload);
      toggleDeleteConfirmation();
      setSelectedRows([]);
    } catch {}
  };

  const handleStatusChange = async (val, item) => {
    console.log(val.target.value, item);
    await updateChoiseStatus(item?._id, { status: val.target.value });
    setReload(!reload);
  };

  const handleExportSelectedProspects = () => {
    if (selectedRows.length === 0) {
      alert("Veuillez sélectionner au moins une ligne à exporter");
      return;
    }

    const headers = [
      { label: "Date de DEMANDE", key: "createdAt" },
      { label: "Tag", key: "tags" },
      { label: "Etat de la demande", key: "prospect_status" },
      { label: "EMAIL", key: "email" },
      { label: "Prenom", key: "firstname" },
      { label: "NOM", key: "lastname" },
      { label: "Abonnement", key: "role" },
      {
        label: "Vehicule souhaite",
        key: "finaliseChoices.general_id.manufacturer.name",
      },
      { label: "Couleur", key: "finaliseChoices.general_id.color.name" },
      { label: "Duree", key: "finaliseChoices.selected_data.duration" },
      { label: "Delivrance", key: "finaliseChoices.delivery_option" },
      { label: "+ 5 ans de permis", key: "license_more_than_5years" },
      { label: "Telephone", key: "phonenumber" },
      { label: "Date de naissance", key: "DOB" },
      { label: "Adresse Complete", key: "address" },
      { label: "Statut", key: "cust_type" },
      { label: "TVA", key: "vat_number" },
    ];

    // Get selected prospects data
    const selectedProspects = basicListData.filter((customer) =>
      selectedRows.includes(customer._id)
    );

    // Format the data for export
    const exportData = selectedProspects.map((customer) => ({
      ...customer,
      createdAt: moment(customer?.createdAt).format("DD/MM/yyyy hh:mm a"),
      tags: customer?.tags?.join(", ") || "",
      role: customer?.role?.join(", ") || "",
      "finaliseChoices.general_id.manufacturer.name": customer?.finaliseChoices
        ?.general_id?.manufacturer?.name
        ? `${customer?.finaliseChoices?.general_id?.manufacturer?.name} ${
            customer?.finaliseChoices?.general_id?.model?.name || ""
          }`
        : "",
      "finaliseChoices.general_id.color.name":
        customer?.finaliseChoices?.general_id?.color?.name || "",
      "finaliseChoices.selected_data.duration": customer?.finaliseChoices
        ?.selected_data?.duration
        ? `${customer?.finaliseChoices?.selected_data?.duration} mois`
        : "",
      license_more_than_5years: customer?.license_more_than_5years
        ? "Oui"
        : "Non",
      DOB: moment(customer?.DOB).format("DD/MM/yyyy"),
      vat_number: customer?.vat_number || "",
      "finaliseChoices.delivery_option":
        customer?.finaliseChoices?.delivery_option || "N/A",
    }));

    exportToCSV(
      exportData,
      `prospects_export_${moment().format("YYYY-MM-DD_HH-mm")}`,
      headers
    );
  };

  const hasAllDetailsFilled = (customer) => {
    // Check basic required fields
    const hasBasicDetails = Boolean(
      customer?.firstname &&
        customer?.lastname &&
        customer?.phonenumber &&
        customer?.email &&
        customer?.DOB &&
        customer?.address &&
        customer?.cust_type
    ); // Customer type is also required

    // If customer type is "Entreprise", check additional business fields
    if (customer?.cust_type === "Entreprise") {
      return Boolean(
        hasBasicDetails &&
          customer?.vat_number &&
          customer?.business &&
          customer?.company?.company_address &&
          customer?.company?.company_contact
      );
    }

    // For other customer types, only basic details are required
    return Boolean(hasBasicDetails);
  };

  const hasFinishedLastStep = (customer) => {
    return customer?.finaliseChoices?.is_sent === true;
  };

  // When no list permission assigned
  if (!permissions.includes("PROSPECT.LIST")) return <></>;

  return (
    <div className="container-fluid flex-grow-1 container-p-y client">
      <div className="card" style={{ borderRadius: "0" }}>
        {showFilters && (
          <div className="d-flex gap-3 p-2">
            {filters.map((filt) => (
              <button
                className="btn fleet-new-filt"
                onClick={() => toggleFilterOpts(filt.key)}
              >
                {filt.label} <BsChevronRight />
              </button>
            ))}
          </div>
        )}
        {filterOpts?.length > 0 && (
          <div className="d-flex gap-3 align-items-center  p-2 ">
            <div className="d-flex gap-3 fleet-new-filt-opt-container">
              <button className="btn fleet-new-filt-opt">
                {filters.find((r) => r.key === filterKey)?.label}
              </button>
              {/* Render DaterangePicker for custom range */}
              {filterKey === "calendar" && (
                <DaterangePicker
                  value={prospectSearches.calendar || []}
                  className="btn fleet-new-filt-opt"
                  onDateChange={(range) => {
                    if (range.start && range.end) {
                      handleDateFilter({
                        range: () => [range.start, range.end],
                      });
                      // handleChange({
                      //   target: {
                      //     name: "calendar",
                      //     value: [range.start, range.end],
                      //   },
                      // });
                    }
                  }}
                />
              )}

              {filterOpts.map((opt) => {
                const optVal =
                  typeof opt === "string" ? opt : opt?.name || opt?.label;
                let isActive =
                  filterKey === "calendar"
                    ? prospectSearches?.calendar &&
                      prospectSearches.calendar[0] === opt.range?.()[0] &&
                      prospectSearches.calendar[1] === opt.range?.()[1]
                    : (typeof prospectSearches[filterKey] === "string"
                        ? prospectSearches[filterKey]
                        : prospectSearches[filterKey]?.name ||
                          prospectSearches[filterKey]?.label) === optVal;
                if (filterKey === "choise_status") {
                  isActive = prospectSearches?.choise_status?.find(
                    (r) => r?.key === opt?.key
                  )
                    ? true
                    : false;
                }
                if (filterKey === "status") {
                  isActive = prospectSearches?.status?.find(
                    (r) => r?.value === opt?.value
                  )
                    ? true
                    : false;
                }
                if (filterKey === "company") {
                  isActive = prospectSearches?.company?.find(
                    (r) => r?._id === opt?._id
                  )
                    ? true
                    : false;
                }
                return (
                  <button
                    key={opt.key || optVal}
                    className={`btn fleet-new-filt-opt ${
                      isActive ? "fleet-new-filt-opt-active" : ""
                    }`}
                    onClick={() =>
                      filterKey === "calendar"
                        ? handleDateFilter(opt) // Handle predefined date ranges
                        : handleChange({
                            target: {
                              name: filterKey,
                              value: opt,
                            },
                          })
                    }
                  >
                    {opt.label || optVal}
                  </button>
                );
              })}
            </div>
            <button
              className="btn fleet-new-filt-opt-clear"
              onClick={toggleFilters}
            >
              <BsChevronLeft />
            </button>
          </div>
        )}
        <div className="d-flex align-items-center white-bg-card-filt">
          <input
            placeholder="Search..."
            className="form-control me-2"
            style={{ width: "200px" }}
            type="text"
            name="search"
            onChange={(e) =>
              dispatch(
                setProspectSearches({
                  ...prospectSearches,
                  search: e.target.value,
                })
              )
            }
            value={prospectSearches?.search}
          />

          {permissions.includes("PROSPECT.ADD") && (
            <button
              className="btn p-2 plus-ic"
              onClick={() => setAddShow(true)}
            >
              <PlusIcon />
            </button>
          )}
          <button
            data-type="filter"
            className={`btn p-2 ${showFilters ? `active-action` : ``}`}
            onClick={toggleFilters}
          >
            <BsFunnel style={{ fontSize: "20px" }} />
          </button>
          <button
            data-type="search"
            className={`btn p-2 ${prospectSearch ? `active-action` : ``}`}
            // onClick={searchMyProspects}
            onClick={(e) => {
              e.stopPropagation();
              // toggleAssignUser(customer);
              overlayPanelRef.current.toggle(e);
            }}
          >
            <ReportSearchIcon />
          </button>
          <button data-type="setting" className="btn p-2">
            <SettingIcon />
          </button>
          <button
            data-type="export"
            className={`btn p-2 ${
              selectedRows.length === 0 ? "opacity-50" : ""
            }`}
            onClick={handleExportSelectedProspects}
            disabled={selectedRows.length === 0}
            title={
              selectedRows.length === 0
                ? "Sélectionnez des lignes pour exporter"
                : `Exporter ${selectedRows.length} ligne(s) sélectionnée(s)`
            }
          >
            <i className="ti ti-download" style={{ fontSize: "20px" }} />
            {selectedRows.length > 0 && (
              <span
                className="badge bg-primary ms-1"
                style={{ fontSize: "10px" }}
              >
                {selectedRows.length}
              </span>
            )}
          </button>
          <button data-type="filter" className="btn p-2">
            <DotsVertIcon />
          </button>
          <div className="d-flex gap-2">
            {Object.values(prospectSearches).length > 0 &&
              Object.entries(prospectSearches).map((k) =>
                k[1] &&
                Array.isArray(k[1]) &&
                ["choise_status", "status", "company"].includes(k[0]) ? (
                  k[1].map((o) => (
                    <div
                      className="selected-filt"
                      role="button"
                      onClick={() => {
                        // setCurrentPage(0);
                        // dispatch(
                        //   setProspectSearches({
                        //     ...prospectSearches,
                        //     [k[0]]: "",
                        //   })
                        // );
                        // setProspectSearch(false);
                        handleChange({
                          target: {
                            name: k[0],
                            value: o,
                          },
                        });
                      }}
                    >
                      {o.label || o?.name}
                      <BsXLg />
                    </div>
                  ))
                ) : k[1] ? (
                  <div
                    className="selected-filt"
                    role="button"
                    onClick={() => {
                      setCurrentPage(0);
                      dispatch(
                        setProspectSearches({
                          ...prospectSearches,
                          [k[0]]: "",
                        })
                      );
                      setProspectSearch(false);
                    }}
                  >
                    {typeof k[1] === "string"
                      ? k[1]
                      : Array.isArray(k[1]) && k[0] === "assignedUser"
                      ? k[1].map((r) => r.label).join(",")
                      : Array.isArray(k[1]) && k[0] === "choise_status"
                      ? k[1].map((r) => r.label).join(", ")
                      : Array.isArray(k[1])
                      ? k[1].join("-")
                      : k[1]?.name || k[1]?.label}{" "}
                    <BsXLg />
                  </div>
                ) : (
                  <></>
                )
              )}

            {selectedRows.length > 0 && !deleteConfirmation && (
              <button
                className="btn btn-primary  p-2"
                onClick={toggleDeleteConfirmation}
              >
                <BsTrash />
                &nbsp;&nbsp; Supprimer
              </button>
            )}
            {selectedRows.length > 0 && deleteConfirmation && (
              <div className="d-flex gap-2  p-2">
                <button className="btn btn-danger" onClick={deleteSelectedRows}>
                  <BsCheck />
                  &nbsp;&nbsp; Valider
                </button>
                <button
                  className="btn btn-default"
                  onClick={toggleDeleteConfirmation}
                >
                  <BsX />
                  &nbsp;&nbsp; Annuler
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="new-table mt-3">
          <div className=" table-responsive">
            <table className="table  table-hover prospect-table" width="100%">
              <thead className="">
                <tr>
                  <th>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                      onChange={(e) =>
                        setSelectedRows(
                          !e.target.checked
                            ? []
                            : basicListData?.map((r) => r._id)
                        )
                      }
                      checked={selectedRows?.length === basicListData?.length}
                    />
                  </th>
                  <th>
                    #{" "}
                    <div className="d-inline-block item-center">
                      <span className="d-flex flex-column ps-1"></span>
                    </div>
                  </th>
                  <th className="d-flex align-items-center">
                    <span className="position-relative top-4">
                      Date de DEMANDE{" "}
                      <span className="mt-1 ps-1">
                        {prospectSortBy?.order === "asc" && (
                          <BsChevronUp
                            fontSize={12}
                            onClick={() => zToaSorting("createdAt")}
                          />
                        )}
                        {prospectSortBy?.order === "desc" && (
                          <BsChevronDown
                            fontSize={12}
                            onClick={() => aTozSorting("createdAt")}
                          />
                        )}
                      </span>
                    </span>
                  </th>
                  <th>
                    <span className="position-relative top-4">Tag</span>
                    <div className="d-inline-block item-center">
                      <span className="d-flex flex-column ps-1"></span>
                    </div>
                  </th>
                  <th>
                    <span className="position-relative top-4">
                      état de la demande
                    </span>
                    <div className="d-inline-block item-center">
                      <span className="d-flex flex-column ps-1"></span>
                    </div>
                  </th>
                  <th>
                    <span className="position-relative top-4">EMAIL</span>
                    <div className="d-inline-block item-center">
                      <span className="d-flex flex-column ps-1"></span>
                    </div>
                  </th>
                  <th>
                    <span className="position-relative top-4">prénom</span>
                    {/* <div className="d-inline-block item-center">
                      <span className="d-flex flex-column ps-1">
                        <BsChevronUp
                          fontSize={12}
                          onClick={() => aTozSorting("firstname")}
                        />
                        <BsChevronDown
                          fontSize={12}
                          onClick={() => zToaSorting("firstname")}
                        />
                      </span>
                    </div> */}
                  </th>
                  <th>
                    <span className="position-relative top-4">NOM</span>
                    {/* <div className="d-inline-block item-center">
                      <span className="d-flex flex-column ps-1">
                        <BsChevronUp
                          fontSize={12}
                          onClick={() => aTozSorting("firstname")}
                        />
                        <BsChevronDown
                          fontSize={12}
                          onClick={() => zToaSorting("firstname")}
                        />
                      </span>
                    </div> */}
                  </th>
                  <th>
                    <span className="position-relative top-4">Abonnement</span>
                    {/* <div className="d-inline-block item-center">
                      <span
                        className="d-flex flex-column ps-1"
                        style={{ opacity: "0" }}
                      >
                        <BsChevronUp fontSize={12} />
                        <BsChevronDown fontSize={12} />
                      </span>
                    </div> */}
                  </th>
                  <th>
                    <span className="position-relative top-4">
                      véhicule souhaité
                    </span>
                  </th>
                  <th>
                    <span className="position-relative top-4">Couleur</span>
                  </th>
                  <th>
                    <span className="position-relative top-4">durée</span>
                  </th>
                  <th>
                    <span className="position-relative top-4">Delivrance</span>
                  </th>
                  <th>
                    <span className="position-relative top-4">LOA</span>
                  </th>
                  <th>
                    <span className="position-relative top-4">
                      + 5 ans de permis
                    </span>
                  </th>
                  <th>
                    <span className="position-relative top-4">téléphone</span>
                  </th>
                  <th>
                    <span className="position-relative top-4">
                      date de naissance
                    </span>
                  </th>
                  <th>
                    <span className="position-relative top-4">
                      Adresse Complète
                    </span>
                  </th>
                  <th>
                    <span className="position-relative top-4">statut</span>
                  </th>
                  <th>
                    <span className="position-relative top-4">TVA</span>
                  </th>

                  <th>ACTIONS </th>
                </tr>
              </thead>
              <tbody>
                {basicListData?.length > 0 &&
                  basicListData?.map((customer, index) => {
                    const hasLicense =
                      customer?.license_more_than_5years || undefined;
                    const prospectUnder23 = isUnder23(customer?.DOB);

                    return (
                      <tr
                        className="cursor-pointer"
                        key={customer?.id}
                        onClick={() => {
                          handleSingleProspect(customer);
                        }}
                      >
                        <td onClick={(e) => e.stopPropagation()}>
                          <input
                            class="form-check-input"
                            type="checkbox"
                            checked={selectedRows.includes(customer._id)}
                            onChange={(e) => {
                              setSelectedRows(
                                !e.target.checked
                                  ? selectedRows.filter(
                                      (r) => r !== customer._id
                                    )
                                  : [...selectedRows, customer._id]
                              );
                            }}
                          />
                        </td>
                        <td>{customer?.index}</td>
                        <td>
                          {moment(customer?.createdAt).format(
                            `DD/MM/yyyy hh:mm a`
                          )}
                        </td>
                        <td onClick={(e) => e.stopPropagation()}>
                          <div
                            style={{
                              display: "flex",
                              width: "250px",
                            }}
                          >
                            <AssignUserModel
                              setReload={() => setReload(!reload)}
                              data={customer}
                              customer={customer}
                              users={users}
                            />
                            <TagsInput
                              value={customer.tags}
                              onChange={(newTags) =>
                                handleTagChange(customer._id, newTags)
                              }
                              placeHolder="tags"
                              style={{
                                height: "20px",
                              }}
                            />
                          </div>
                        </td>
                        <td
                          onClick={(e) => e.stopPropagation()}
                          style={{
                            paddingTop: "0px",
                            paddingBottom: "0px",
                            heigth: "32px",
                          }}
                        >
                          <Dropdown
                            value={customer?.prospect_status}
                            options={[
                              {
                                label: "Call 1",
                                key: "call_1",
                              },
                              {
                                label: "Mail 1",
                                key: "mail_1",
                              },
                              {
                                label: "Call 2",
                                key: "call_2",
                              },
                              {
                                label: "Call 3",
                                key: "call_3",
                              },
                              {
                                label: "Mail 2",
                                key: "mail_2",
                              },
                              {
                                label: "Mail 3",
                                key: "mail_3",
                              },
                              {
                                label: "Contrat envoyé",
                                key: "contract_sent",
                              },
                              {
                                label: "Traité",
                                key: "treaty",
                              },
                              {
                                label: "Conversion",
                                key: "conversion",
                              },
                              {
                                label: "Cloturé",
                                key: "cloture",
                              },
                              {
                                label: "Pas éligible",
                                key: "pas_eligible",
                              },
                              {
                                label: "A Traiter",
                                key: "a_traiter",
                              },
                              {
                                label: "Document manquant",
                                key: "document_manquant",
                              },
                            ]}
                            onChange={(e) => handleStatusChange(e, customer)}
                            placeholder="demande d’abonnement"
                            style={{
                              width: "100%",
                              height: "32px",
                              padding: 0,
                            }}
                            optionLabel="label"
                            optionValue="key"
                            // disabled={!customer?.finaliseChoices}
                            filter
                          />
                        </td>
                        <td>{customer?.email}</td>
                        <td>{customer?.firstname}</td>
                        <td>{customer?.lastname}</td>
                        <td>
                          <div className="d-flex gap-2">
                            {customer?.role.map((role, i) => (
                              <span
                                key={i}
                                className={`fs-13 ${roleClasses[role]}`}
                              >
                                {customer?.role?.includes("SINGLE") &&
                                role === "CLIENT"
                                  ? "C"
                                  : role}
                              </span>
                            ))}
                            {/* {["treaty", "conversion", "contract_sent"].includes(
                              customer?.prospect_status
                            ) && (
                              <span className="bg-success rounded px-2 c-badge">
                                <i
                                  className="menu-icon text-white tf-icons ti ti-checkup-list m-0 fs-5"
                                  type="button"
                                />
                              </span>
                            )} */}
                            {["document_manquant"].includes(
                              customer?.prospect_status
                            ) &&
                              customer?.finished_onboarding === false &&
                              !customer?.DOB &&
                              !customer?.license_more_than_5years && (
                                <span className="bg-dark rounded px-2 c-badge">
                                  <i
                                    className="menu-icon text-white tf-icons ti ti-file m-0 fs-5"
                                    type="button"
                                  />
                                </span>
                              )}

                            {["document_manquant"].includes(
                              customer?.prospect_status
                            ) &&
                              customer?.finished_onboarding === true && (
                                <span className="bg-warning rounded px-2 c-badge">
                                  <i
                                    className="menu-icon text-white tf-icons ti ti-file m-0 fs-5"
                                    type="button"
                                  />
                                </span>
                              )}

                            {(["pas_eligible"].includes(
                              customer?.prospect_status
                            ) ||
                              customer?.license_more_than_5years === false ||
                              prospectUnder23) && (
                              <span className="bg-danger rounded px-2 c-badge">
                                <i
                                  className="menu-icon text-white tf-icons ti ti-id-badge m-0 fs-5"
                                  type="button"
                                />
                              </span>
                            )}

                            {!["pas_eligible"].includes(
                              customer?.prospect_status
                            ) &&
                              (hasLicense === false || prospectUnder23) && (
                                <span className="bg-danger rounded px-2 c-badge">
                                  <i
                                    className="menu-icon text-white tf-icons ti ti-id-badge m-0 fs-5"
                                    type="button"
                                  />
                                </span>
                              )}

                            {/* {hasAllDetailsFilled(customer) &&
                              !hasFinishedLastStep(customer) && (
                                <span className="bg-warning rounded px-2 c-badge">
                                  <i
                                    className="menu-icon text-white tf-icons ti ti-file m-0 fs-5"
                                    type="button"
                                  />
                                </span>
                              )}
                            {hasAllDetailsFilled(customer) &&
                              hasFinishedLastStep(customer) && (
                                <span
                                  className="bg-info rounded px-2 c-badge"
                                  style={{
                                    backgroundColor: "rgba(0, 132, 255, 1)",
                                  }}
                                >
                                  <i
                                    className="menu-icon text-white tf-icons ti ti-checkup-list m-0 fs-5"
                                    type="button"
                                  />
                                </span>
                              )} */}
                            {["a_traiter"].includes(
                              customer?.prospect_status
                            ) && (
                              <span
                                className="bg-info rounded px-2 c-badge"
                                style={{
                                  backgroundColor: "#40E0D0",
                                }}
                              >
                                <i
                                  className="menu-icon text-white tf-icons ti ti-checkup-list m-0 fs-5"
                                  type="button"
                                />
                              </span>
                            )}
                          </div>
                        </td>
                        <td className="font-weight-bold">
                          {
                            customer?.finaliseChoices?.general_id?.manufacturer
                              ?.name
                          }{" "}
                          {customer?.finaliseChoices?.general_id?.model?.name}
                        </td>
                        <td className="font-weight-bold">
                          {customer?.finaliseChoices?.general_id?.color?.name}
                        </td>
                        <td className="font-weight-bold">
                          {customer?.finaliseChoices?.selected_data?.duration
                            ? `${customer?.finaliseChoices?.selected_data?.duration} mois`
                            : ``}
                        </td>
                        <td className="font-weight-bold">
                          {`${
                            customer?.finaliseChoices?.delivery_option || `N/A`
                          }`.toUpperCase()}
                        </td>
                        <td className="font-weight-bold">
                          {customer?.finaliseChoices?.loa || "N/A"}
                        </td>
                        <td className="font-weight-bold">
                          {customer?.license_more_than_5years ? "Oui" : "Non"}
                        </td>
                        <td className="font-weight-bold">
                          {customer?.phonenumber}
                        </td>
                        <td className="font-weight-bold">
                          {moment(customer?.DOB).format(`DD/MM/yyyy`)}
                        </td>
                        <td className="font-weight-bold">
                          {customer?.address}
                        </td>
                        <td className="font-weight-bold">
                          {customer?.cust_type}
                        </td>
                        <td className="font-weight-bold">
                          {customer?.vat_number || ""}
                        </td>

                        <td>
                          <i
                            className="ti ti-trash"
                            onClick={(e) => {
                              e.stopPropagation();
                              setModalShow(true);
                              setclientId(customer?._id);
                            }}
                            style={{ cursor: "pointer", fontSize: "20px" }}
                          />
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>

            {!loading && (basicList?.length === 0 || !basicList) && (
              <div className="text-center my-4 mx-auto">No Data Found</div>
            )}

            {loading && (
              <div className="text-center my-4 mx-auto">
                <Loader />
              </div>
            )}
          </div>
        </div>
        {basicList?.length > 0 && (
          <TableFooter
            itemsPerPage={itemsPerPage}
            handleSelectChange={handleSelectChange}
            listData={basicList}
            handlePageChange={handlePageChange}
            pagination={prospectPagination}
          />
        )}

        {/* add prospect */}
        {addShow && (
          <AddNewProspect
            show={addShow}
            onHide={() => setAddShow(false)}
            setclientId={setclientId}
          />
        )}

        {modalShow && (
          <DeleteModal
            title={"Supprimer Cette Prospect"}
            description={"Êtes-vous sûr de supprimer le Prospect ?"}
            show={modalShow}
            clientId={clientId}
            deleteData={() => handleDelete(false)}
            onHide={() => setModalShow(false)}
          />
        )}

        <OverlayPanel ref={overlayPanelRef} dismissable style={{ padding: 0 }}>
          <SearchableOptions
            value={prospectSearches?.assignedUser || []}
            options={users}
            onChange={handleSubmitAssignedUser}
            placeholder="Select an user"
            style={{ width: "100%" }}
            optionLabel="fullName"
            optionValue="_id"
            multiple
          />
          {/* <Dropdown
            value={prospectSearches?.assignedUser}
            options={users}
            onChange={handleSubmitAssignedUser}
            placeholder="Select an user"
            style={{ width: "100%" }}
            optionLabel="fullName"
            optionValue="_id"
            filter
            multiple
          /> */}
          {/* 
        {customer?.assignedUser && (
          <button className="btn btn-danger mt-2" onClick={handleSubmit}>
            <BsXLg />
            &nbsp;&nbsp; Remove
          </button>
        )} */}
        </OverlayPanel>
      </div>
    </div>
  );
};

export default Prospect;

const AssignUserModel = ({ data, setReload, customer, users }) => {
  const overlayPanelRef = useRef(null);

  const handleSubmit = async (e) => {
    await updataClientUserApi(data._id, { userId: e?._id || "" });
    setReload();
    overlayPanelRef.current.toggle(e);
  };

  return (
    <>
      <div
        style={{
          border: "1px solid #DBDADE",
          padding: "0 5px",
          borderRadius: "6px 0 0 6px",
          background: customer?.assignedUser ? `#0084FF52` : `#FFF`,
          display: "flex",
          alignItems: "center",
        }}
        className="assign-u"
        role="button"
        onClick={(e) => {
          e.stopPropagation();
          // toggleAssignUser(customer);
          overlayPanelRef.current.toggle(e);
        }}
      >
        {!customer?.assignedUser && <BsPersonPlus />}
        {customer?.assignedUser &&
          `${customer?.assignedUser?.fname.charAt(
            0
          )} ${customer?.assignedUser?.lname.charAt(0)}`}
      </div>
      <OverlayPanel ref={overlayPanelRef} dismissable style={{ padding: 0 }}>
        {/* <Dropdown
          // value={selectedOption}
          options={users}
          onChange={handleSubmit}
          placeholder="Select an user"
          style={{ width: "100%" }}
          optionLabel="fullName"
          filter
        /> */}

        <SearchableOptions
          value={[]}
          options={users}
          onChange={handleSubmit}
          placeholder="Select an user"
          style={{ width: "100%" }}
          optionLabel="fullName"
          optionValue="_id"
          multiple
        />

        {customer?.assignedUser && (
          <button className="btn btn-danger mb-2 mx-3" onClick={handleSubmit}>
            <BsXLg />
            &nbsp;&nbsp; Remove
          </button>
        )}
      </OverlayPanel>
    </>
  );
};
